import {mapState} from 'vuex'

/**
 * Possible states of a passwort input
 * @type {Readonly<{valid: string, tooShort: string, sameAsUsername: string, unsafe: string, tooLong: string, empty: string}>}
 */
export const PasswordState = Object.freeze({
  empty: 'PASSWORD.EMPTY',
  valid: 'PASSWORD.VALID',
  tooShort: 'PASSWORD.TOO_SHORT',
  unsafe: 'PASSWORD.UNSAFE',
  tooLong: 'PASSWORD.TOO_LONG',
  sameAsUsername: 'PASSWORD.SAME_AS_USERNAME',
})

export default {
  data () {
    return {
      /**
       * Current state of the password
       */
      passwordState: PasswordState.empty,
    }
  },
  computed: {
    ...mapState(['username', 'password']),
    /**
     * Return true if the password is valid
     * @returns {boolean}
     */
    passwordValid () {
      const state = this.getPasswordState()
      return state === PasswordState.valid || state === PasswordState.unsafe
    }
  },
  methods: {
    /**
     * Return true if the password
     * @returns {boolean}
     */
    isPasswordSafe () {
      let alphaSize = 0
      if (/[a-z]/.test(this.password)) alphaSize += 26
      if (/[A-Z]/.test(this.password)) alphaSize += 26
      if (/[0-9]/.test(this.password)) alphaSize += 10
      if (/[^a-zA-Z0-9]/.test(this.password)) alphaSize += 15
      const bits = Math.log2(alphaSize) * this.password.length

      return bits > 48
    },
    /**
     * Check the password and return the current state
     *
     * @returns {*}
     */
    getPasswordState () {
      if (this.password.length === 0) return PasswordState.empty
      if (this.password.toLowerCase() === this.username.toLowerCase()) return PasswordState.sameAsUsername
      if (this.password.length < 6) return PasswordState.tooShort
      if (this.password.length > 15) return PasswordState.tooLong
      if (!this.isPasswordSafe(this.password)) return PasswordState.unsafe
      return PasswordState.valid
    },

  },
}
